export enum YearHouseBuilded {
  BEFORE_1915 = '_1915',
  FROM_1915_TO_1948 = '_1915_1948',
  FROM_1949_TO_1967 = '_1949_1967',
  FROM_1968_TO_1974 = '_1968_1974',
  FROM_1975_TO_1981 = '_1975_1981',
  FROM_1982_TO_1989 = '_1982_1989',
  FROM_1990_TO_1999 = '_1990_1999',
  FROM_2000_TO_2005 = '_2000_2005',
  FROM_2006_TO_2012 = '_2006_2012',
  AFTER_2013 = '_2013',
  Inconnue = 'Unknown',
}
